import { createContext, useContext } from "react";
import type { Role } from "@/data/role-defaults";

export const RoleContext = createContext<Role | null>(null);

export const RoleProvider = RoleContext.Provider;

export function useRole(): Role | null {
  return useContext(RoleContext);
}
